import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ProfileImage } from '@xingternal/profile-image';
import styles from './Item.css';
function Item({ data: { title, url, subtitle, thumbnail, trackingToken, position, userId }, getItemProps, isHighlighted, icon, searchType, }) {
    return (React.createElement("a", { ...getItemProps({
            item: {
                title,
                url,
                trackingData: {
                    interaction_type: 'view',
                    consumer: 'rest.api.search.incremental_search',
                    service: 'ds.incremental_search.universal',
                    tracking_token: trackingToken,
                    position: position,
                    user_id: userId,
                },
            },
            href: url,
            className: cx(styles.item, {
                [styles.highlighted]: isHighlighted,
            }),
        }) },
        icon ? (React.createElement("div", { className: styles.icon }, icon)) : (React.createElement(ProfileImage, { profileName: title, src: thumbnail, patternId: `search-profile-picture-${searchType}-${position}`, className: styles.imageContainer, size: "small", "data-qa": "item-image" })),
        React.createElement("article", { className: styles.content },
            React.createElement("div", { className: styles.title }, title),
            subtitle && React.createElement("p", { className: styles.subtitle }, subtitle))));
}
const ItemType = PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    url: PropTypes.string.isRequired,
    thumbnail: PropTypes.string,
    trackingToken: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
    userId: PropTypes.string.isRequired,
});
Item.propTypes = {
    data: ItemType.isRequired,
    getItemProps: PropTypes.func.isRequired,
    isHighlighted: PropTypes.bool.isRequired,
    isQuerySuggestion: PropTypes.bool,
    icon: PropTypes.node,
    searchType: PropTypes.string,
};
export default Item;
//# sourceMappingURL=Item.js.map